// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__6B9VR","loaderContainerOpaque":"loader_loaderContainerOpaque__CwANt","loader":"loader_loader__A9x27"};